import React from 'react';

const About = () => {
  return (
    <section className="about-section" id='about'>
      <div className="about-container">
        <h1 className="about-main-heading">About Us</h1>
        
        <div className="about-content">
          <p className="about-text">
            Lutlo Apps is a mobile app development studio specializing in Flutter-based applications for iOS and Android. We create free, high-quality apps across categories like AI tools, productivity, sports tracking, and entertainment, all available on the Google Play Store and Apple App Store.
          </p>
          
          <p className="about-text">
            Beyond our portfolio, we offer custom app development services for businesses and entrepreneurs. From concept to launch, we handle design, development, app store publishing, and ongoing support—delivering complete solutions where you retain full ownership of your app.
          </p>
          
        </div>
      </div>
    </section>
  );
}

export default About;

